/**
 * WEB-2534 — дверь стиль-пака публичной страницы (воронка, пейволл, пейволл,
 * встроенный в квиз, предпросмотр, отдача тела с резолва хоста).
 *
 * Пак воронки приезжает лениво (`loadStylePack`), а рендер читает его
 * синхронно (`getStylePackById`). Поэтому «ждём ли» не хранится в состоянии,
 * а ВЫВОДИТСЯ на каждой отрисовке из самого реестра: тело воронки попало в
 * состояние любым путём (запрос страницы, тело с резолва хоста, встроенный
 * пейволл) — в том же кадре пак не на руках, и страница показывает прелоадер.
 * Отдельной «закрывашки» в обработчике ответа нет по построению: её можно
 * забыть на одном из входов, а вывод из реестра забыть нельзя.
 *
 * Ждать нечего: пак не задан, это пак по умолчанию, он уже приехал, его кусок
 * отказал (тогда рисуется пак по умолчанию) или id выдуман. Отказ не держит
 * страницу на прелоадере вечно — `loadStylePack` не бросает.
 */
import { useEffect, useState } from 'react';
import { hasStylePackLoaded, loadStylePack } from './stylePacks';

export interface StylePackDoor {
  readonly waiting: boolean;
}

export function useStylePackDoor(
  stylePackIds: ReadonlyArray<string | null | undefined>,
): StylePackDoor {
  const [, setArrived] = useState(0);
  const pending = stylePackIds.filter(
    (id): id is string => !!id && !hasStylePackLoaded(id),
  );
  const key = pending.join('|');

  useEffect(() => {
    if (key === '') return;
    let alive = true;
    void Promise.all(key.split('|').map((id) => loadStylePack(id))).then(() => {
      if (alive) setArrived((n) => n + 1);
    });
    return () => {
      alive = false;
    };
  }, [key]);

  return { waiting: pending.length > 0 };
}
